import { mapState } from 'vuex';

const toastMixin = {
  data() {
    return {
      alertMessage: undefined,
      loaderEnabled: false,
    };
  },
  computed: {
    ...mapState('appStore', ['appData']),
  },
  created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'appStore/updateAppData') {
        this.loaderEnabled = state.appStore.appData.inProgress;
        if (state.appStore.appData.message) {
          const newMessage = state.appStore.appData.message;

          // Don't overwrite modal messages with snackbar messages
          // Modal messages should persist until user closes them
          if (this.alertMessage &&
              this.alertMessage.component === 'modal' &&
              newMessage.component === 'snackbar' && newMessage.content === 'Error') {
            return;
          }

          this.alertMessage = newMessage;
        }
      }
    });
  },
};

export default toastMixin;
